import React, { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

const testimonials = [

  {
    name: "John Doe",
    position: "CEO",
    company: "MediLogix",
    description:
      "Impact Logistics has transformed our medical supply chain, ensuring timely deliveries.",
    image: "https://randomuser.me/api/portraits/men/46.jpg",
  },
  {
    name: "Jane Smith",
    position: "Head of Operations",
    company: "HealthFlow",
    description:
      "Exceptional service! We rely on them for all our urgent medical logistics needs.",
    image: "https://randomuser.me/api/portraits/men/46.jpg",
  },
  {
    id: 4,
    name: "Emily Rodriguez",
    role: "Clinic Supervisor",
    company: "Family Care Center",
    image: "https://randomuser.me/api/portraits/women/45.jpg",
    text: "Their service has been instrumental in helping us maintain our high standards of patient care.",
  },
  {
    id: 5,
    name: "David Wilson",
    role: "Medical Director",
    company: "Wilson Medical Group",
    image: "https://randomuser.me/api/portraits/men/46.jpg",
    text: "Impact Logistics provides the reliability and security we need for our sensitive medical deliveries.",
  },
];

const TestimonialSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevIndex =
    (currentIndex - 1 + testimonials.length) % testimonials.length;
  const nextIndex = (currentIndex + 1) % testimonials.length;
  const prev2Index =
    (currentIndex - 2 + testimonials.length) % testimonials.length;
  const next2Index = (currentIndex + 2) % testimonials.length;

  // Autoplay functionality
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 5000); // Change testimonial every 5 seconds

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="bg-gray-100 p-8 rounded-lg max-w-7xl mx-auto">
      <h3 className="lg:text-2xl text-xl text-center lg:text-left font-bold text-gray-800">
        What people say <span className="font-extrabold">about us</span>
      </h3>
      <div className="flex items-center w-full space-y-6 lg:flex-row flex-col">
        {/* Center - Testimonial Content */}
        <AnimatePresence mode="wait">
          <motion.div
            key={currentIndex}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className="lg:w-2/3 w-full flex flex-col items-center lg:items-start justify-center"
          >
            <h3 className="text-2xl font-bold text-gray-800"></h3>
            <p className="text-gray-600 mt-4 italic">
              {testimonials[currentIndex].description ||
                testimonials[currentIndex].text}
            </p>
            <p className="mt-4 font-bold text-gray-800">
              {testimonials[currentIndex].name}
            </p>
            <p className="text-primary-light">
              {testimonials[currentIndex].position ||
                testimonials[currentIndex].role}{" "}
              - {testimonials[currentIndex].company}
            </p>
          </motion.div>
        </AnimatePresence>

        <div className="relative flex flex-row items-center justify-center gap-x-2 lg:flex-col">
          {/* Previous 2 Image */}
          <motion.img
            src={testimonials[prev2Index].image}
            alt={testimonials[prev2Index].name}
            className="w-4 h-4 rounded-full opacity-30 cursor-pointer lg:absolute lg:-top-16"
            onClick={() => setCurrentIndex(prev2Index)}
            whileHover={{ scale: 1.2 }}
          />
          {/* Previous Image */}
          <motion.img
            src={testimonials[prevIndex].image}
            alt={testimonials[prevIndex].name}
            className="w-8 h-8 rounded-full opacity-50 cursor-pointer lg:absolute lg:-top-10"
            onClick={() => setCurrentIndex(prevIndex)}
            whileHover={{ scale: 1.2 }}
          />
          {/* Current Image */}
          <motion.img
            key={currentIndex}
            src={testimonials[currentIndex].image}
            alt={testimonials[currentIndex].name}
            className="w-24 h-24 rounded-full border-4 border-white shadow-lg"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3 }}
          />
          {/* Next Image */}
          <motion.img
            src={testimonials[nextIndex].image}
            alt={testimonials[nextIndex].name}
            className="w-8 h-8 rounded-full opacity-50 cursor-pointer lg:absolute lg:-bottom-10"
            onClick={() => setCurrentIndex(nextIndex)}
            whileHover={{ scale: 1.2 }}
          />
          {/* Next 2 Image */}
          <motion.img
            src={testimonials[next2Index].image}
            alt={testimonials[next2Index].name}
            className="w-4 h-4 rounded-full opacity-30 cursor-pointer lg:absolute lg:-bottom-16"
            onClick={() => setCurrentIndex(next2Index)}
            whileHover={{ scale: 1.2 }}
          />
        </div>


        {/* Right Side - Navigation */}
        <div className="flex lg:flex-col lg:space-y-2 lg:items-center lg:space-x-0 lg:ml-5 flex-row space-x-2">
          {testimonials.map((_, index) => (
            <motion.button
              key={index}
              className={`w-2 h-2 rounded-full ${
                index === currentIndex ? "bg-primary-light" : "bg-gray-300"
              }`}
              onClick={() => setCurrentIndex(index)}
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialSlider;
